"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tutorialTranslations = {
    'tutorial.noDescription': 'Brak dostępnego opisu',
    'tutorial.allCategories': 'Wszystkie kategorie',
    'tutorial.noCategory': 'Bez kategorii',
    'tutorial.list.subtitle': 'Wybierz szkolenie, aby kontynuować naukę.',
    'tutorial.lessons': 'lekcji',
    'tutorial.unstarted': 'nierozpoczęte',
    'tutorial.done': 'ukończone',
    'tutorial.repeat': 'powtórz',
    'tutorial.motivation': 'Przed Tobą {allSections} zadań w {allSteps} działach. Pierwszy temat już czeka.',
    'tutorial.searchPlaceholder': 'Szukaj poradników...',
    'tutorial.category.list.title': 'Kategorie szkoleń',
    'tutorial.category.list.subtitle': 'Zarządzaj kategoriami dostępnymi w szkoleniach.',
    'tutorial.category.create.button': 'Dodaj kategorię',
    'tutorial.category.create.title': 'Nowa kategoria',
    'tutorial.category.edit.title': 'Edytuj kategorię',
    'tutorial.category.name': 'Nazwa kategorii',
    'tutorial.category.namePlaceholder': 'Wprowadź nazwę kategorii',
    'tutorial.category.description': 'Opis',
    'tutorial.category.descriptionPlaceholder': 'Wprowadź opis kategorii',
    'tutorial.category.color': 'Kolor',
    'tutorial.category.colorPlaceholder': 'Wybierz kolor',
    'tutorial.category.icon': 'Ikona',
    'tutorial.category.iconPlaceholder': 'Wybierz ikonę',
    'tutorial.category.isActive': 'Aktywna',
    'tutorial.category.nameRequired': 'Nazwa kategorii jest wymagana',
    'tutorial.category.loadFailed': 'Nie udało się załadować kategorii',
    'tutorial.category.saveFailed': 'Nie udało się zapisać kategorii',
    'tutorial.category.createSuccess': 'Kategoria została utworzona',
    'tutorial.category.updateSuccess': 'Kategoria została zaktualizowana',
    'tutorial.category.deleteFailed': 'Nie udało się usunąć kategorii',
    'tutorial.category.delete.success': 'Kategoria została usunięta',
    'tutorial.category.delete.confirm': 'Potwierdź usunięcie',
    'tutorial.category.delete.confirmText': 'Czy na pewno chcesz usunąć tę kategorię?',
    'tutorial.category.list.empty.title': 'Brak kategorii',
    'tutorial.category.list.empty.message': 'Nie znaleziono żadnych kategorii. Dodaj pierwszą kategorię, aby rozpocząć.',
    'tutorial.steps': 'kroków',
    'tutorial.sections': 'sekcji',
    'tutorial.noTasks': 'Brak zadań dostępnych dla tej sekcji',
    'tutorial.created': 'Poradnik został pomyślnie utworzony',
    'tutorial.updated': 'Poradnik został pomyślnie zaktualizowany',
    'tutorial.saveFailed': 'Nie udało się zapisać poradnika',
    'tutorial.loadFailed': 'Nie udało się ładować poradnika',
    'tutorial.loadListFailed': 'Nie udało się załadować poradników',
    'tutorial.deleteFailed': 'Nie udało się usunąć poradnika',
    // Additional tutorial translations
    'tutorial.catalog': 'Katalog Poradników',
    'tutorial.sectionsPlaceholder': 'Brak dostępnych sekcji',
    'tutorial.yourTraining': 'Twoje Szkolenie',
    'tutorial.yourTasks': 'Twoje Zadania',
    'tutorial.completed': 'Postęp szkolenia',
    'tutorial.chatDescription': 'Użyj czatu, aby zadawać pytania i uzyskać pomoc',
    'tutorial.tasksTitle': 'Zadania',
    'tutorial.taskPlaceholder': 'Opis zadania',
    'tutorial.notFound': 'Nie znaleziono poradnika',
    'tutorial.unnamedSection': 'Sekcja bez nazwy',
    'tutorial.unnamedStep': 'Krok bez nazwy',
    'tutorial.inProgress': 'W trakcie',
    'tutorial.notStarted': 'Nie rozpoczęte',
    'tutorial.continue': 'Kontynuuj',
    'tutorial.start': 'Rozpocznij',
    'tutorial.restart': 'Zrestartuj',
    'tutorial.finish': 'Zakończ',
    'tutorial.progress': 'Postęp',
    'tutorial.estimatedTime': 'Szacowany czas',
    'tutorial.difficulty': 'Poziom trudności',
    'tutorial.beginner': 'Początkujący',
    'tutorial.intermediate': 'Średniozaawansowany',
    'tutorial.advanced': 'Zaawansowany',
    'tutorial.prerequisites': 'Wymagania wstępne',
    'tutorial.objectives': 'Cele nauki',
    'tutorial.resources': 'Zasoby',
    'tutorial.downloadResources': 'Pobierz zasoby',
    'tutorial.printInstructions': 'Wydrukuj instrukcje',
    'tutorial.shareProgress': 'Udostępnij postęp',
    'tutorial.giveFeedback': 'Wystawy opinię',
    'tutorial.reportIssue': 'Zgłoś problem',
    'tutorial.certificate': 'Certyfikat',
    'tutorial.downloadCertificate': 'Pobierz certyfikat',
    'tutorial.panel': 'Panel szkoleń'
};
exports.default = tutorialTranslations;
